import { useApiEffect } from "nsitools-react";
import * as React from "react";
import styled from "styled-components";
import { BroodRequestApi } from "../../../api";
import { useApiService } from "../../../hooks";
import { ETLCodes } from "../../../locales";
import { useTl } from "../../../hooks";
import { NonIdealState, Spinner } from "@blueprintjs/core";
import { BabyDogCard } from "./BabyDogCard";
import { isBrcs } from "../../DrupalApp";

export interface IDrupalBabyDogListProps {
  breedId: number;
}
const Container = styled.div`
  display: flex;
  flex-direction: column;
`;

export const DrupalBabyDogList: React.FunctionComponent<IDrupalBabyDogListProps> = ({ breedId }) => {
  const api = useApiService(BroodRequestApi);
  const [data, loadingData] = useApiEffect(async () => await api.getAvailableBabyDog(breedId, isBrcs), [breedId]);
  const { t } = useTl();
  return loadingData ? (
    <Spinner />
  ) : (
    <Container>
      {!breedId ? (
        <NonIdealState icon="series-search" title={t(ETLCodes.PLeaseSelectBreed)} />
      ) : data?.length === 0 ? (
        <NonIdealState icon="search" title={t(ETLCodes.NoBabyDogForBreed)} />
      ) : (
        data?.map((c, key) => <BabyDogCard babyDog={c} key={key} />)
      )}{" "}
    </Container>
  );
};
